import validator from 'validator';
import {DATATYPE} from "core/metamodel/mdField";
import {loc} from "core/common/config/locales";
import moment from "moment";
import {CZECH_PHONE_CODE_PREFIX, CZECH_PHONE_PATTERN} from "core/common/utils/constant";


export interface RuleResult {
  valid: boolean;
  reason: string;
}

export function valid(): RuleResult {
  return {valid: true, reason: null}
}

export function invalid(reason: string): RuleResult {
  return {valid: false, reason}
}

export function validWarn(reason: string): RuleResult {
  return {valid: true, reason}
}


export function IsEmail({value}): RuleResult & any {
  return (validator.isEmail(value)) ?
    valid() : invalid('Please enter a valid email.')
}

export function IsMobilePhone({value}): RuleResult & any {
  return (validator.isMobilePhone(value, ['bg-BG', 'cs-CZ', 'de-DE', 'da-DK', 'el-GR', 'en-AU', 'en-CA', 'en-GB', 'en-US', 'es-ES', 'fr-FR', 'hu-HU', 'it-IT', 'lt-LT', 'pl-PL', 'ro-RO', 'ru-RU', 'sl-SI', 'sk-SK', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'] as any, {strictMode: true})) ?
    valid() : invalid(loc.i18n`Please enter a valid mobile phone number`)
}


export function IsRequired({value, condition}): RuleResult & any {

  return ((value != null && value !== '') || condition === false) ?
    valid() : invalid('This field is required')
}

export function IsNumber({value}): RuleResult & any {
  return (value == null || !isNaN(value)) ?
    valid() : invalid('Please enter a valid number');
}

export function Max({value, max}): RuleResult & any {
  if (!isNaN(value) && /\S/.test(value)) {
    return (Number(value) <= max) ? valid() : invalid('Maximum value is ' + max);
  } else {
    return valid();
    // TODO: dates
  }
}

(<any>Max).parameters = {
  max: DATATYPE.NUMBER
};


export function Min({value, min}): RuleResult & any {
  if (!isNaN(value) && /\S/.test(value)) {
    return (Number(value) >= min) ? valid() : invalid('Minimum value is ' + min);
  } else {
    return valid();
    // TODO: dates
  }
}

(<any>Min).parameters = {
  min: DATATYPE.NUMBER
};

export function NumberFormat({value, precision, scale}): RuleResult & any {
  return (value == null || new RegExp("^(\\-?\\d{0," + precision + "}\\.\\d{0," + scale + "}|\\-?\\d{0," + precision + "}|\\-?\\.\\d{0," + scale + "})$").test(value)) ?
    valid() : invalid('Value does not have a correct format');
}

(<any>NumberFormat).parameters = {
  precision: DATATYPE.NUMBER,
  scale: DATATYPE.NUMBER
};

export function HasNumber({value}): RuleResult & any {
  return (value != null && value.match(/.*[0-9]+.*/i) != null) ?
    valid() : invalid('This field should contain at least one digit.')
}

export function HasLength({value, min, max}: {value?: string, min?: number, max?: number}): RuleResult & any {
  if (value == null) {
    return invalid('Value cannot be null.')
  }
  if (min != null && value.length < min) {
    return invalid(`Length should be at least ${min}.`)
  }
  if (max != null && value.length > max) {
    return invalid(`Length should be at most ${max}.`)
  }
  return valid()
}

(<any>HasLength).parameters = {
  max: DATATYPE.NUMBER,
  min: DATATYPE.NUMBER
};

export function AreSame({value1, value2}): RuleResult & any {
  return value1 === value2 ?
    valid() : invalid('Values have to match.')
}

export function PrimaryKeyString({value}): RuleResult & any {
  return (!value || new RegExp('^[a-z0-9-]+$', 'i').test(value)) ?
    valid() : invalid('String can contain only letters and numbers and dash')
}

export function ForbiddenNames({value, names}: { value: any, names: string[] }): RuleResult & any {
  return (value && names.includes(value)) ?
    invalid('Value must not be one of ' + names) : valid();
}

export function Pattern({value, pattern}): RuleResult & any {
  return (!value || new RegExp(pattern).test(value)) ?
    valid() : invalid('Value does not have a correct format');
}

export function CountryPhoneFormat({value, pattern}): RuleResult & any {
  if (!value || new RegExp(pattern).test(value)) {
    if (new RegExp(CZECH_PHONE_CODE_PREFIX).test(value))
      return (new RegExp(CZECH_PHONE_PATTERN).test(value)) ? valid() : invalid('Value does not have a correct format');
    return valid();
  } else
    return invalid('Value does not have a correct format');
}

export function MinDateOrPrevious({value, min, previous}): RuleResult & any {
  if (!value) return valid();

  value = moment(value, "YYYY-MM-DD");

  min.startOf("day");
  previous.startOf("day");

  if (value.isSame(previous) || value.diff(min, "days") >= 0) {
    return valid();
  } else {
    return invalid('Min value is ' + min.format("DD.MM.YYYY"));
  }
}

(<any>Min).parameters = {
  pattern: DATATYPE.STRING
};



// WEBPACK FOOTER //
// ./src/core/form/rules.ts